import { Section } from "@/components/builder/IdentitySection";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const LANGS = [["auto", "Automático (idioma del usuario)"], ["español", "Español"], ["inglés", "Inglés"], ["portugués", "Portugués"], ["francés", "Francés"], ["alemán", "Alemán"], ["italiano", "Italiano"], ["catalán", "Catalán"]];

const Bars = ({ v, label }) => (
  <div className="flex items-center gap-2">
    <span className="w-16 text-[10px] uppercase tracking-wider text-zinc-600">{label}</span>
    <div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((n) => <span key={n} className={`h-1.5 w-4 ${n <= v ? "bg-cyan-400" : "bg-white/10"}`} />)}</div>
  </div>
);

export const ModelSection = ({ form, set, meta }) => {
  const vendors = [...new Set(meta.models.map((m) => m.vendor))];
  return (
    <Section id="model" title="Modelo y estilo" desc="El cerebro del agente y cómo se expresa.">
      {vendors.map((v) => (
        <div key={v}>
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-widest text-zinc-500">{v}</p>
          <div className="grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
            {meta.models.filter((m) => m.vendor === v).map((m) => {
              const active = form.model === m.id && form.provider === m.provider;
              return (
                <button key={m.id} onClick={() => { set("provider", m.provider); set("model", m.id); }} className={`relative p-4 text-left ${active ? "bg-blue-600/10" : "bg-[#080808] hover:bg-[#101010]"}`} data-testid={`builder-model-${m.id}`} style={{ transition: "background-color 160ms" }}>
                  {active && <span className="absolute inset-y-0 left-0 w-0.5 bg-blue-500" />}
                  <div className="flex items-center justify-between"><p className="font-semibold">{m.label}</p><span className={`text-[10px] uppercase tracking-wider ${m.premium ? "text-amber-400" : "text-zinc-500"}`}>{m.tier}</span></div>
                  <p className="mt-1 text-xs text-zinc-500">{m.description}</p>
                  <div className="mt-3 space-y-1"><Bars v={m.speed} label="Velocidad" /><Bars v={m.reasoning} label="Razonar" /></div>
                </button>
              );
            })}
          </div>
        </div>
      ))}
      <div>
        <label className="label">Tono</label>
        <div className="flex flex-wrap gap-2">
          {meta.tones.map((t) => (
            <button key={t} onClick={() => set("tone", t)} className={`border px-3 py-1.5 text-sm capitalize ${form.tone === t ? "border-blue-500 bg-blue-600 text-white" : "border-white/10 text-zinc-400 hover:text-white"}`} data-testid={`builder-tone-${t}`}>{t}</button>
          ))}
        </div>
      </div>
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label className="label">Extensión de respuesta</label>
          <div className="grid grid-cols-3 border border-white/10">
            {meta.lengths.map((l) => (
              <button key={l} onClick={() => set("response_length", l)} className={`py-2 text-sm capitalize ${form.response_length === l ? "bg-white text-black" : "text-zinc-400 hover:text-white"}`} data-testid={`builder-length-${l}`}>{l}</button>
            ))}
          </div>
        </div>
        <div>
          <label className="label">Idioma</label>
          <Select value={form.language} onValueChange={(v) => set("language", v)}>
            <SelectTrigger className="h-[42px] rounded-sm border-white/10 bg-[#0d0d0d]" data-testid="builder-language-select"><SelectValue /></SelectTrigger>
            <SelectContent className="border-white/10 bg-[#121212] text-white">{LANGS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
    </Section>
  );
};

export const InstructionsSection = ({ form, set }) => (
  <Section id="instructions" title="Instrucciones" desc="El núcleo del comportamiento. Define rol, objetivos, proceso y formato. Nunca se muestra a los compradores.">
    <div>
      <label className="label">Prompt de sistema</label>
      <textarea value={form.system_prompt} onChange={(e) => set("system_prompt", e.target.value)} rows={12} maxLength={20000} className="field font-mono !text-xs leading-relaxed" placeholder="Eres un experto en… Tu objetivo es… Sigue este proceso: 1)… 2)…" data-testid="builder-system-prompt-input" />
      <p className="mt-1 text-right font-mono text-[11px] text-zinc-600">{form.system_prompt.length}/20000</p>
    </div>
    <div>
      <label className="label">Límites y reglas obligatorias</label>
      <textarea value={form.guardrails} onChange={(e) => set("guardrails", e.target.value)} rows={5} maxLength={3000} className="field font-mono !text-xs leading-relaxed" placeholder={"No des precios cerrados sin consultar.\nNo hables de la competencia.\nDeriva a un humano si el cliente lo pide."} data-testid="builder-guardrails-input" />
    </div>
  </Section>
);
